export const LEDGER_SNAPSHOT = "LEDGER_SNAPSHOT";
export const LEDGER_DETAIL = "LEDGER_DETAIL";
export const LEDGER_DETAIL_FILTER = "LEDGER_DETAIL_FILTER";
export const LEDGER_DETAIL_SORT = "LEDGER_DETAIL_SORT";
export const LEDGER_DETAIL_SORT_CLEAR = "LEDGER_DETAIL_SORT_CLEAR";
export const LEDGER_SNAPSHOT_EXTENTION = "LEDGER_SNAPSHOT_EXTENTION";
export const LEDGER_CONTRACT_NOTE = "LEDGER_CONTRACT_NOTE";
